// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"492e6b75","946":"8508f210","970":"92962f13"}[chunkId] + ".chunk.js";
};